import {TradingInstrument} from '../trading-instruments/trading-instrument.class';
import {TradingInstrumentKind} from '../trading-instruments/trading-instrument-kind.enum';
import {QuoteDto} from '../shell-communication/dtos/quote-dto.class';

export interface PhaHedgeProductGroup {
    category: string;
    settlement: 'Cash Settled' | 'Assignable';
    tickers: ReadonlyArray<string>;
}

export const PHA_HEDGE_PRODUCT_COLUMNS: ReadonlyArray<{heading: string, groups: ReadonlyArray<PhaHedgeProductGroup>}> = [
    {heading: 'BROAD MARKET', groups: [
        {category: 'S&P 500', settlement: 'Cash Settled', tickers: ['SPX', 'XSP']},
        {category: '', settlement: 'Assignable', tickers: ['SPY']},
        {category: 'OTHERS', settlement: 'Cash Settled', tickers: ['NDX', 'RUT']},
        {category: '', settlement: 'Assignable', tickers: ['QQQ', 'IWM']},
        {category: 'COMMODITIES', settlement: 'Assignable', tickers: ['GLD']}
    ]},
    {heading: 'SECTORS', groups: [
        {category: '', settlement: 'Assignable', tickers: ['XLE', 'XLF', 'XLK', 'XLV', 'XLI', 'XLP', 'XLY', 'XLU', 'XLB', 'XLRE', 'XLC']}
    ]}
];

export const PHA_HEDGE_PRODUCT_TICKERS: ReadonlyArray<string> = PHA_HEDGE_PRODUCT_COLUMNS
    .reduce((all, column) => all.concat(...column.groups.map(group => Array.from(group.tickers))), [] as string[]);

// Temporary availability switch: preserve the complete catalog above for re-enabling.
export const PHA_TEMPORARILY_HIDDEN_HEDGE_PRODUCTS: ReadonlyArray<string> = ['NDX', 'RUT'];
export const PHA_AVAILABLE_HEDGE_PRODUCT_TICKERS = PHA_HEDGE_PRODUCT_TICKERS
    .filter(ticker => PHA_TEMPORARILY_HIDDEN_HEDGE_PRODUCTS.indexOf(ticker) < 0);
export const PHA_AVAILABLE_HEDGE_PRODUCT_COLUMNS = PHA_HEDGE_PRODUCT_COLUMNS.map(column => ({...column,
    groups: column.groups.map(group => ({...group, tickers: group.tickers.filter(ticker =>
        PHA_TEMPORARILY_HIDDEN_HEDGE_PRODUCTS.indexOf(ticker) < 0)}))}));

export interface PhaHedgeProductRow {
    ticker: string;
    name: string;
    price: number | null;
    contractValue: number | null;
}

/** Standard stock/ETF and index options represent 100 units, matching the instrument generator's lot rule. */
export function hedgeProductRow(ticker: string, instrument: TradingInstrument, quote: QuoteDto): PhaHedgeProductRow {
    const supported = instrument && instrument.ticker === ticker
        && (instrument.kind === TradingInstrumentKind.Stock || instrument.kind === TradingInstrumentKind.Index);
    const last = quote && quote.ticker === ticker ? quote.lastPx : null;
    const price = supported && typeof last === 'number' && isFinite(last) && last > 0 && isFinite(last * 100) ? last : null;
    return {ticker, name: instrument ? (instrument.description || instrument.displayName || ticker) : 'Unavailable',
        price, contractValue: price === null ? null : price * 100};
}
